import { Icon } from '@iconify/react'
import { Button, Spinner, Tooltip } from '@nextui-org/react'
import { FileIcon, TrashIcon } from 'lucide-react'
import { useState, useCallback, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import api from 'src/lib/api'

interface ICreateDropZone {
  isRequired?: boolean
  title?: string
  description?: string
  userUUID?: string
  isForUser?: boolean
  files?: any[]
  onFilesChange?: (files: any[]) => {}
}

export default function CreateDropZone({ title, description, userUUID, files, onFilesChange, isForUser }: ICreateDropZone) {
  const [loading, setLoading] = useState<boolean>(false)
  const uploadFile = async (file: File) => {
    const formData = new FormData()
    formData?.append('file', file)
    const res = await api.post(isForUser? `/agencies/files`: `/admin/files/${userUUID}`, formData)
    return res.data
  }
  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      setLoading(true)
      const files = await Promise.all(acceptedFiles.map((file) => uploadFile(file)))
      onFilesChange?.(files)
      setLoading(false)
    },
    [uploadFile, userUUID],
  )
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
  })
  const removeFile = () => {
    //!TODO - remove file
  }
  return (
    <div className="flex flex-col flex-1">
      <span className={'flex flex-row items-center gap-1 text-small'}>
        <span className="font-medium">{title}</span>{' '}
        <Tooltip content={description} color="foreground">
          <Icon icon={'lucide:circle-help'} />
        </Tooltip>
      </span>
      <div
        {...getRootProps({
          className: 'relative flex flex-col gap-2 mt-2 bg-default-100 rounded-xl justify-center items-center',
        })}
      >
        {loading && (
          <div className="p-2 flex flex-row absolute top-0 right-0 rounded-tr-xl rounded-bl-xl bg-white justify-center items-center gap-2">
            <Spinner size={'sm'} />
            <span className="text-sm text-default-500">Uploading...</span>
          </div>
        )}
        <input {...getInputProps()} />
        <div className={'flex flex-col justify-center items-center p-4'}>
          {files && files.length > 0 ? (
            files.map((item) => (
              <>
                <FileIcon className={'w-[120px] mb-5'} />
                <span className="text-xs font-bold text-default-500 text-wrap">{item.filename}</span>
                <div className={'flex gap-2'}>
                  <Button variant="bordered" color={'danger'} className={''} onPress={removeFile}>
                    <TrashIcon />
                    Delete File
                  </Button>
                </div>
              </>
            ))
          ) : (
            <>
              <div className={'bg-white p-2 rounded-full mb-2'}>
                <Icon icon={'lucide:cloud-upload'} />
              </div>
              <p className={'font-regular text-sm'}>
                <span className={'pr-1 font-medium text-blue-400 cursor-pointer'} onClick={open}>
                  Click to upload
                </span>
                or drag and drop
              </p>
              <span className={'text-xs font-regular'}>SVG, PNG, JPG or GIF (max.800x400px)</span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
